export default {
  title: 'Pseudo-permission',
  studio: {
    description: 'Inspect role permissions and manage permission cache.',
    companyGroup: 'Company group',
    roleType: 'Role type',
    employeeCode: 'Employee code',
    lookup: 'Role lookup',
    fetch: 'Fetch role pseudo-permission',
    result: 'Response',
    empty: 'No response to display. Enter a Role ID and fetch permissions.'
  },
  home: 'Home',
  company: 'Company',
  cache: {
    button: 'Clear permission cache',
    invalidRoleId:
      'Enter role_id as a non-negative integer within the supported range.',
    success: 'Permission cache cleared for role_id {{roleId}}.',
    failed: 'Cannot clear permission cache. Please try again.',
    fetchFailed: 'Cannot fetch role pseudo-permission.',
    hint: 'Clearing cache does not update permissions in current sessions. Affected users must sign out and sign in again to receive the latest permissions. Fetch reads directly from PIS and does not populate the cache.'
  },
  'delete-row-modal': {
    title: 'Pseudo-permission',
    content: 'Would you like to delete this seletced item?',
    button: {
      accept: 'YES',
      cancel: 'NO'
    }
  },
  form: {
    startPeriod: {
      label: 'Start date',
      placeholder: 'Start date'
    },
    endPeriod: {
      label: 'End date',
      placeholder: 'End date'
    }
  }
}
